// Event states
export const Replay = 0;
export const Past = 1;
export const StartingSoon = 2;
export const Live = 3;
export const Future = 4;

const StartingSoonDistance = 60_000 * 15;

export const updateEventState = (events, now = new Date()) => events.map(e => {
  let state;
  if (now < e.startTime - StartingSoonDistance) state = Future;
  else if (now < e.startTime) state = StartingSoon;
  else if (now < e.endTime) state = Live;
  else state = e.replayStream ? Replay : Past;
  return {...e, state}
})